import { useContext, useEffect, useState } from 'react'
import { stylesheet } from './ChatWidget.scss'
import onlineIcon from '../../assets/images/online_icon.svg'
import offlineIcon from '../../assets/images/offline_icon.svg'
import { withTranslation } from 'react-i18next'
import { Typography, Button, ResponsiveImage, Box, FlexBox, Icon } from '@vp/swan'
import { ChatStatusContext } from '../../contexts/ChatStatusProvider'
import { useStyles, useUserContext } from '@vp/ubik-context'
import chatbotHelper from '../../helpers/chatbotHelper'

const ChatWidget = (props) => {
  const { tenant, locale, startChat, t } = props
  const { featureFlags } = useUserContext()
  const lng = locale.toLowerCase().replace('-', '_')
  const {
    state: { chatStatus },
  } = useContext(ChatStatusContext)
  useStyles(stylesheet)

  const isChatbotEnabled = chatbotHelper.enableChatbot(locale, featureFlags?.['ca-chatbot-ubik'] === 'true')

  const chatConfig = {
    online: {
      chatHeader: isChatbotEnabled ? t(`${tenant}:chatbot.title`, { lng }) : t(`${tenant}:chat.title`, { lng }),
      chatAvailabilityText: t(`${tenant}:pre_footer.links.live_chat.online.status`, { lng }),
      chatDescription: isChatbotEnabled ? t(`${tenant}:chatbot.description`, { lng }) : t(`${tenant}:chat.description`, { lng }),
      buttonText: t(`${tenant}:chat.buttons.chat_now.title`, { lng }),
      buttonState: 'active',
      status: 'online',
    },
    offline: {
      chatHeader: isChatbotEnabled ? t(`${tenant}:chatbot.title`, { lng }) : t(`${tenant}:chat.title`, { lng }),
      chatAvailabilityText: t(`${tenant}:pre_footer.links.live_chat.offline.status`, { lng }),
      chatDescription: isChatbotEnabled ? t(`${tenant}:chatbot.offline_description`, { lng }) : t(`${tenant}:chat.buttons.chat_offline.description`, { lng }),
      buttonText: t(`${tenant}:chat.buttons.chat_offline.title`, { lng }),
      buttonState: 'disabled',
      status: 'offline',
    },
    unavailable: {
      chatHeader: isChatbotEnabled ? t(`${tenant}:chatbot.title`, { lng }) : t(`${tenant}:chat.title`, { lng }),
      chatAvailabilityText: t(`${tenant}:pre_footer.links.live_chat.offline.status`, { lng }),
      chatDescription: isChatbotEnabled
        ? t(`${tenant}:chatbot.offline_description`, { lng })
        : t(`${tenant}:chat.buttons.chat_unavailable.description`, { lng }),
      buttonText: t(`${tenant}:chat.buttons.chat_unavailable.title`, { lng }),
      buttonState: 'disabled',
      status: 'offline',
    },
    preparing: {
      chatHeader: isChatbotEnabled ? t(`${tenant}:chatbot.title`, { lng }) : t(`${tenant}:chat.title`, { lng }),
      chatAvailabilityText: t(`${tenant}:pre_footer.links.live_chat.online.status`, { lng }),
      chatDescription: isChatbotEnabled ? t(`${tenant}:chatbot.description`, { lng }) : t(`${tenant}:chat.description`, { lng }),
      buttonText: t(`${tenant}:chat.buttons.chat_loading.title`, { lng }),
      buttonState: 'disabled',
      status: 'online',
    },
    chatting: {
      chatHeader: isChatbotEnabled ? t(`${tenant}:chatbot.title`, { lng }) : t(`${tenant}:chat.title`, { lng }),
      chatAvailabilityText: t(`${tenant}:pre_footer.links.live_chat.online.status`, { lng }),
      chatDescription: isChatbotEnabled ? t(`${tenant}:chatbot.description`, { lng }) : t(`${tenant}:chat.description`, { lng }),
      buttonText: t(`${tenant}:chat.buttons.chatting.title`, { lng }),
      buttonState: 'disabled',
      status: 'online',
    },
  }

  /** This will store the data to be displayed in chat section */
  const [widgetDetails, setWidgetDetails] = useState()

  /** set widget info based on chat state */
  useEffect(() => {
    if ((chatStatus && chatStatus !== 'initial') || chatStatus !== 'loading') {
      setWidgetDetails(chatConfig[chatStatus])
    }
  }, [chatStatus])

  return (
    <FlexBox style={{ height: '100%' }} paddingRight="2" flexDirection="column" justifyContent="space-between" textAlign="left">
      <FlexBox flexDirection="column">
        <Box>
          <FlexBox>
            <Typography fontSkin="title-subsection" mb={4}>
              {widgetDetails?.chatHeader}
            </Typography>
          </FlexBox>
        </Box>
        <Box>
          <FlexBox>
            <FlexBox id="salesforceChatStatusDiv">
              <ResponsiveImage role="presentation" aspectratio="1" src={widgetDetails?.status === 'online' ? onlineIcon : offlineIcon} alt="" width="12px" />
              <Typography fontSkin="title-item" component="span" ml="3">
                {widgetDetails?.chatAvailabilityText}
              </Typography>
            </FlexBox>
          </FlexBox>
        </Box>
      </FlexBox>
      <Box>
        <Box style={{ width: '100%' }}>
          <Typography component="span" fontSize="standard">
            {widgetDetails?.chatDescription}
          </Typography>
        </Box>
      </Box>
      <Box pt="5">
        <Box style={{ width: '100%' }}>
          <Button onClick={startChat} skin="secondary" type="button" disabled={widgetDetails?.buttonState === 'disabled'} iconPosition="left">
            <Icon iconType="liveChat" />
            {widgetDetails?.buttonText}{' '}
          </Button>
        </Box>
      </Box>
    </FlexBox>
  )
}
export default withTranslation()(ChatWidget)
